import React from "react";
import s from "./avatar-setting.module.scss";
import { useProfile } from "@shared/api/useProfile";
import { useUpdateAvatarModal } from "@features/profile/update-avatar/model/use-update-avatar-modal";
import { IconEdit } from "@tabler/icons-react";
import { SettingRow } from "../setting-row/setting-row";

export const AvatarSetting = () => {
  const { data: profile } = useProfile();

  const { open: openUpdateAvatarModal } = useUpdateAvatarModal();

  return (
    <SettingRow
      title="Ваше фото"
      subtitle="Здесь вы можете изменить свою аватарку"
    >
      <div className={s.avatar}>
        <button className={s.edit} onClick={() => openUpdateAvatarModal()}>
          <IconEdit size={24} color="#fff" />
        </button>
        <img
          src={
            profile?.avatar
              ? process.env.REACT_APP_STORAGE_URL + profile.avatar.image
              : process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
          }
          alt=""
        />
      </div>
    </SettingRow>
  );
};
